import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import IconCancel from '@material-ui/icons/Cancel';
import Payment from '@material-ui/icons/Payment';
import ThumbUp from '@material-ui/icons/ThumbUp';

//import NumberFormat from 'react-number-format';

import React, { Fragment, useEffect, useState } from 'react';
import {
    Button, useNotify,useRefresh
} from 'react-admin';
import { devises, has_role, modePayement} from '../references';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(1),
    },
    textField: {
        width: '50ch',
    },
}));

const json = (response) => {
    return response.json()
}


export default function FormDialogPayement(props) {
    //const redirect = useRedirect();
    const notify = useNotify();
    const refresh = useRefresh();
    //const form = useForm();
    const [showDialog, setShowDialog] = useState(false);
    //const [currency, setCurrency] = React.useState('EUR');

    //const [totalTTC, setTotalTTC] = React.useState();
    const [restPaye, setRestPaye] = React.useState();
    const [montant, setMontant] = React.useState();
    const [numero, setNumero] = React.useState();
    const [modePay, setModePay] = React.useState("espece");
    //const [roles, setRole] = useState();
    //const [montantInitial, setMontantInitial] = useState();
    const [devise, setDevise] = useState();
    const [tauxFG, setTauxFG] = React.useState();
    const [tauxUSD, setTauxUSD] = React.useState();
    const [listeModePayement, setListeModePayement] = React.useState();
    const classes = useStyles();

    const handleClick = () => {
        setShowDialog(true);
    };

    const handleCloseClick = () => {
        let isMontantPositif=false;
        var ret = false;
        let message='';
        let isOkForSend=false;
        var montantConverti=0;

        if(modePay!=='espece' && modePay!=='virmen' && (!numero || numero==='')){
            notify('Si vous souhaitez faire un enregistrement par carte ou cheque vous devez fournir le numero !!','warning');
            return null;
        }else if(modePay==='carte' && numero.length>16){
            notify("Vous devez saisir le numéro Auto de 6 chiffres ou bien les 16 caractères se trouvant au dessus de la date de fin de validité sur l'étiquette commerçant",'warning');
            return null;
        }else if(modePay==='cheque' && (numero.length<7  || numero.length>8)){
            notify("Vous devez saisir le numéro du cheque comportant 7 ou 8 chiffres",'warning');
            return null;
        }

        if(montant>0) isMontantPositif=true;
        let montant_format=new Intl.NumberFormat().format(montant);
        if(devise==='FG'){
            message ="Etes vous sure d'avoir reçu le montant de " +montant_format+ " " + devise + " ?";
            montantConverti=restPaye*tauxFG;
            isOkForSend=montant <= montantConverti;
            
        }else if(devise==='USD'){
            message ="Etes vous sure d'avoir reçu le montant de " + montant_format+ " " + devise + " ?";
            montantConverti=restPaye*tauxUSD;
            isOkForSend=montant <= montantConverti;
        }else{
            message ="Etes vous sure d'avoir reçu le montant de " + montant_format + " " + devise + " ?";
            isOkForSend=montant <= restPaye;
            montantConverti=restPaye;
        }

        if (isOkForSend && isMontantPositif) {
            setShowDialog(false);
           
            ret = window.confirm(message);
            if (!ret) setShowDialog(true);

            if (ret) {
                var id = props.for === 'livraison' ? props.data.ord_id : props.data.id;

                fetch(process.env.REACT_APP_URL + '/caisse', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8',
                        "Authorization": "Bearer " + localStorage.getItem('token')
                    },
                    body: JSON.stringify({
                        "ord_id": id, "montant": montant,
                        "devise": devise, "modePay": modePay,'numero':numero
                    })
                }
                ).then(json)
                    .then((data) => {
                        //console.log(props.data);
                        if (data.status === "success") {
                            //notify(data.message);
                            //refresh();
                            //console.log(data.object.value);
                            //setRestPaye(data.object.value);
                            window.location.reload();

                        } else if (data.status > 310) {
                            notify(data.message, "error");
                            refresh();
                        } else {
                            notify(data.message, "error");
                        }


                    }).catch((e) => {
                        notify("Erreur lors du processus de l'enregistrement du payement, veuillez réessayer, ou contacter le responsable.", 'warning')
                    });

            }


        }else{
            message= isMontantPositif ? "Le montant saisi "+montant+' '+devise+" ne doit pas être supérieur au reste à payé "+montantConverti+" "+devise+"!"
                            : "Vous ne pouvez pas encaisser un montant négatif !";
            notify(message, "error");
        }
    };

    const handleAnnulerCloseClick = () => {
        setShowDialog(false);

    };


    useEffect(() => {
        //console.log(permissions);
        const taux_fg=localStorage.getItem('tauxFG');
        //setRole(localStorage.getItem('roles'));
        
        setTauxUSD(localStorage.getItem('tauxUSD'));
        //const taux=localStorage.getItem('taux');
        setTauxFG(taux_fg);
        if (props.data ) {
            //setTotalTTC(props.data.total_general);
            setRestPaye(props.data.reste_a_payer);
        }

        has_role(localStorage.getItem('roles'), 'ROLE_AG_EXP_AERIEN_GUI') ? setDevise('FG') : setDevise('EU');
        //alert(tauxFG);
        if(has_role(localStorage.getItem('roles'), 'ROLE_AG_EXP_AERIEN_GUI') ){
            
            setMontant(props.data.reste_a_payer * taux_fg)
        }else{
            //alert(props.data.reste_a_payer );
            setMontant(props.data.reste_a_payer);
        }

        
        if(has_role(localStorage.getItem('roles'), 'ROLE_AG_EXP_AERIEN_GUI') ){
            const modesPaies=modePayement.filter(item=>item.id!=='virmen').filter(item=>item.id!=='carte');
            setListeModePayement(modesPaies);
        }else if(has_role(localStorage.getItem('roles'), 'ROLE_MANAGER')){
            setListeModePayement(modePayement);
        }else if(has_role(localStorage.getItem('roles'), 'ROLE_AG_EXP_AERIEN_FR') || has_role(localStorage.getItem('roles'), 'ROLE_AG_EXP_MARITIME_FR') ){
            const modesPaies=modePayement.filter(item=>item.id!=='virmen');
            setListeModePayement(modesPaies);
        }else{
            setListeModePayement(null);
        }
        
    }, []);


    const handleMontantChange = (event) => {
        event.preventDefault();
        setMontant(event.target.value);
    }

    const modePayChange = (event) => {
        event.preventDefault();
        setModePay(event.target.value);
    }

    const deviseChange = (event) => {
        event.preventDefault();
        setDevise(event.target.value);
        event.target.value==='FG' ? setMontant(restPaye*tauxFG):event.target.value==='USD' ? setMontant(restPaye*tauxUSD): setMontant(restPaye);
        //alert(montantInitial+devise);
        //console.log(event.target.value);
    }

    const handleNumeroChange=(event)=>{
        event.preventDefault();
        setNumero(event.target.value);
    }

    /*

    const [value, setValue] = React.useState('Controlled');

    const handleChange = (event) => {
        setValue(event.target.value);
    };
    */


    //if(!taux || (taux && !taux.fg)) return null;


    return (

        <Fragment>


            <Button onClick={handleClick} label="Payé">
                <Payment />
            </Button>

            <Dialog

                open={showDialog}
                onClose={handleCloseClick}
                aria-label="Enregistrer un paiement"
            >
                <DialogTitle>Enregistrer un payement</DialogTitle>
                <DialogContent>

                    <form className={classes.root} noValidate autoComplete="off">
                        <FormControl fullWidth className={classes.margin}>
                            <TextField
                                select
                                label="Mode payement"
                                value={modePay}
                                onChange={modePayChange}
                                variant="filled"
                            >
                                {listeModePayement && listeModePayement.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {option.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                         
                        </FormControl>

                        <FormControl fullWidth className={modePay==='espece' || modePay==='virmen' ? null:classes.margin}>
                          
                            { modePay==='espece' || modePay==='virmen' ? null :
                                  <TextField
                                  required
                                  label={'Numéro'}
                                  value={numero}
                                  onChange={handleNumeroChange}
                                  variant="filled"
                                  fullWidth
                              />
                            }
                        </FormControl>


                        <FormControl fullWidth className={classes.margin}>

                            <TextField

                                select
                                label="Devise"
                                value={devise}
                                onChange={deviseChange}
                                variant="filled"
                            >
                                {devises.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {option.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </FormControl>

                        <FormControl fullWidth className={classes.margin}>
                            <div >
                                <TextField
                                    label="Reste à payé (EU)"
                                    type="number"
                                    value={restPaye}
                                    variant="filled"
                                    fullWidth
                                    disabled
                                />
                            </div>
                        </FormControl>


                        <FormControl fullWidth className={classes.margin}>
                                <TextField
                                    label={'Montant ('+devise+')'}
                                    type="number"
                                    required
                                   // defaultValue={devise==='FG' ? restPaye*tauxFG:restPaye}
                                    value={montant}
                                    onChange={handleMontantChange}
                                    variant="filled"
                                    fullWidth
                                    
                                />
                        </FormControl>
                </form>

                </DialogContent>
                <DialogActions>
                    <Button
                        label="Annuler"
                        onClick={handleAnnulerCloseClick}

                    >
                        <IconCancel />
                    </Button>
                    <Button
                        label="Ok"
                        onClick={handleCloseClick}
                    >

                        <ThumbUp />
                    </Button>

                </DialogActions>



            </Dialog>

        </Fragment>
    );
};

//export default PostQuickCreateButton;
